// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"bec_a bha_sl","StrollerBoxWidget__imageCounselling":"bec_b bha_jz"};